/* Native wishlist. Stores product handles in localStorage — no app, no network.
   Cards render the heart already; this gives it behaviour and keeps it in sync
   across AJAX collection filtering, which replaces the grid wholesale. */
(function () {
  'use strict';

  var KEY = 'hce-wishlist';
  var EVENT = 'hce:wishlist:change';

  function read() {
    try {
      var raw = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(raw) ? raw.filter(function (h) { return typeof h === 'string'; }) : [];
    } catch (e) {
      /* Private mode, cleared storage, or a corrupt value — start empty. */
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* Quota or blocked storage: the in-page state below still updates. */
    }
    document.dispatchEvent(new CustomEvent(EVENT, { detail: { items: list } }));
  }

  function has(handle) {
    return read().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) list.push(handle); else list.splice(i, 1);
    write(list);
    return i === -1;
  }

  function paint(button) {
    var handle = button.getAttribute('data-wishlist-handle');
    if (!handle) return;
    var on = has(handle);
    var title = button.getAttribute('data-wishlist-title') || 'this item';
    button.classList.toggle('is-wishlisted', on);
    button.setAttribute('aria-pressed', on ? 'true' : 'false');
    button.setAttribute('aria-label', (on ? 'Remove ' : 'Add ') + title + (on ? ' from' : ' to') + ' wishlist');
  }

  function paintAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var buttons = scope.querySelectorAll('.hce-card-wishlist[data-wishlist-handle]');
    for (var i = 0; i < buttons.length; i++) paint(buttons[i]);
  }

  function paintCount() {
    var n = read().length;
    var nodes = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = n;
      nodes[i].hidden = n === 0;
    }
  }

  /* Delegated so it survives the grid being replaced by AJAX filtering. */
  document.addEventListener('click', function (e) {
    var button = e.target.closest && e.target.closest('.hce-card-wishlist');
    if (!button) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = button.getAttribute('data-wishlist-handle');
    if (!handle) return;
    var added = toggle(handle);
    paintAll();
    if (typeof window.hceToast === 'function') {
      window.hceToast(added ? 'Saved to your wishlist' : 'Removed from your wishlist');
    }
  });

  document.addEventListener(EVENT, paintCount);

  function init() {
    paintAll();
    paintCount();
    /* Collection filtering swaps the grid in; re-paint whatever arrives. */
    var grid = document.querySelector('.hce-shop__grid, #product-grid');
    if (grid && window.MutationObserver) {
      new MutationObserver(function () { paintAll(); }).observe(grid, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.HCEWishlist = { read: read, has: has, toggle: toggle, clear: function () { write([]); paintAll(); } };
})();
